// extracted by mini-css-extract-plugin
export default {"filterChip":"FilterChips_filterChip__nMtvW"};